import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=760e1dc7&lang=less&scoped=true"
import "./pc_style.less?vue&type=style&index=1&id=760e1dc7&lang=less&scoped=true"
import "./mobile_style.less?vue&type=style&index=2&id=760e1dc7&lang=less&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-760e1dc7"]])

export default __exports__